import React from "react";
import Scrollchor from "react-scrollchor";
export default () => (
  <section id="one" className="spotlight style1 bottom">
    <span className="image fit main">
      <img src="" alt="" />
    </span>
    <div className="content">
      <div className="container">
        <div className="row">
          <div className="col-4 col-12-medium">
            <header>
              <h2>Introduction</h2>
              <p style={{ fontSize: ".9em", fontWeight: "light !important" }}>
                Hello! I'm Isaac. Nice to meet you.
                I am a highly motivated MVC/React and Vue full-stack developer who's amassed knowledge in the inner workings of MVC architecture.
              </p>
            </header>
          </div>
          <div className="col-4 col-12-medium">
            <p>
              My contributions to open-source projects are continuously increasing and I am glad to give back to the community so that other software developers can also benefit.
              I actually rank 13th on Stack Overflow for contributions as of this date!
            </p>
          </div>
          <div className="col-4 col-12-medium">
            <p>
              I have also built a number of front-facing applications that allow users to benefit on a day to day basis.
              I love tooling and have built several tools and libraries that have helped me automate repetitive tasks. To see some of my projects, please view them below.
            </p>
          </div>
        </div>
      </div>
    </div>

    <Scrollchor
        to={"#two"}
        className={"goto-next"}
        animate={{offset: 20, duration: 600}}
    >
      Next
    </Scrollchor>

  </section>
);
